import { Box, BoxProps } from "@hightouch/htui";

export function GlowLogo(props: BoxProps) {
  return (
    <Box as="svg" boxSize="72px" fill="none" viewBox="0 0 72 72" {...props}>
      <g opacity=".4">
        <g clipPath="url(#glow-logo-svg__a)">
          <g
            filter="url(#glow-logo-svg__b)"
            style={{ mixBlendMode: "hard-light" }}
          >
            <path
              fill="url(#glow-logo-svg__c)"
              fillRule="evenodd"
              d="M46.76 7.196c4.937-8.491 18.529-3.903 28.245-5.341 9.583-1.42 19.573-7.442 28.191-3.015 8.616 4.425 11.45 15.314 13.964 24.667 2.112 7.855 1.68 16.085-.939 23.785-2.304 6.772-7.909 11.344-12.789 16.574-5.098 5.464-9.469 11.54-16.29 14.59-8.526 3.814-18.559 8.898-26.921 4.736-8.362-4.16-11.253-15.069-12.454-24.33-.982-7.577 6.676-13.745 6.528-21.383-.208-10.66-12.893-21.066-7.534-30.283Z"
              clipRule="evenodd"
            />
          </g>
          <g
            filter="url(#glow-logo-svg__d)"
            style={{ mixBlendMode: "darken" as const }}
          >
            <path
              fill="url(#glow-logo-svg__e)"
              fillRule="evenodd"
              d="M24.781 30.046c-5.803-1.574-5.243-10.339-7.634-15.856-2.357-5.443-7.502-10.396-6.25-16.194C12.15-7.8 18.14-11.202 23.272-14.171c4.31-2.493 9.246-3.542 14.214-3.213 4.37.29 7.962 2.88 11.829 4.937 4.038 2.149 8.324 3.77 11.209 7.32 3.606 4.44 8.203 9.567 7.066 15.172-1.136 5.604-7.129 9.043-12.416 11.22-4.324 1.781-9.185-1.77-13.679-.472-6.271 1.812-10.415 10.962-16.715 9.254Z"
              clipRule="evenodd"
            />
          </g>
          <g
            filter="url(#glow-logo-svg__f)"
            style={{ mixBlendMode: "hard-light" as const }}
          >
            <path
              fill="url(#glow-logo-svg__g)"
              fillRule="evenodd"
              d="M7.832 56.67c-14.906-1.056-32.985 5.328-42.109-6.506-9.623-12.482-6.603-32.002 2.493-44.873C-24.142-5.52-7.922-.49 4.587-4.825c13.878-4.81 26.516-24.054 38.739-15.911 12.194 8.123.18 27.129.095 41.781-.071 12.132 8.032 26.007-.542 34.59-8.69 8.7-22.782 1.906-35.047 1.036Z"
              clipRule="evenodd"
            />
          </g>
        </g>
        <rect
          width="71"
          height="71"
          x=".5"
          y=".5"
          stroke="#000"
          strokeOpacity=".16"
          rx="35.5"
          style={{ mixBlendMode: "plus-darker" as const }}
        />
      </g>
      <g filter="url(#glow-logo-svg__h)">
        <rect width="64" height="64" x="4" y="4" fill="#232323" rx="32" />
        <g clipPath="url(#glow-logo-svg__i)">
          <path
            fill="#fff"
            d="M30.887 21.237c0-.319.258-.577.577-.577h19.299c.319 0 .577.258.577.577v19.299a.577.577 0 0 1-.577.577H30.887V21.237Z"
          />
          <path
            fill="#fff"
            d="M30.887 50.763a.577.577 0 0 1-.578.577h-9.072a.577.577 0 0 1-.577-.577V41.69c0-.32.258-.578.577-.578h9.65v9.65Z"
          />
        </g>
      </g>
      <defs>
        <filter
          id="glow-logo-svg__b"
          width="187.06"
          height="201.507"
          x="-11.558"
          y="-59.758"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            result="effect1_foregroundBlur_5873_1359"
            stdDeviation="28.5"
          />
        </filter>
        <filter
          id="glow-logo-svg__d"
          width="171.063"
          height="161.7"
          x="-46.296"
          y="-74.443"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            result="effect1_foregroundBlur_5873_1359"
            stdDeviation="28.5"
          />
        </filter>
        <filter
          id="glow-logo-svg__f"
          width="288.99"
          height="282.736"
          x="-140.2"
          y="-122.72"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            result="effect1_foregroundBlur_5873_1359"
            stdDeviation="50"
          />
        </filter>
        <filter
          id="glow-logo-svg__h"
          width="64"
          height="64"
          x="4"
          y="4"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            radius="1"
            result="effect1_innerShadow_5873_1359"
          />
          <feOffset />
          <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0" />
          <feBlend in2="shape" result="effect1_innerShadow_5873_1359" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            radius="2"
            result="effect2_innerShadow_5873_1359"
          />
          <feOffset />
          <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
          <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0" />
          <feBlend
            in2="effect1_innerShadow_5873_1359"
            result="effect2_innerShadow_5873_1359"
          />
        </filter>
        <linearGradient
          id="glow-logo-svg__c"
          x1="89.999"
          x2="57.501"
          y1="3"
          y2="41.001"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8471FF" />
          <stop offset="1" stopColor="#35EAD5" />
        </linearGradient>
        <linearGradient
          id="glow-logo-svg__e"
          x1="10.001"
          x2="43.072"
          y1="-14"
          y2="18.337"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBC2C2" />
          <stop offset="1" stopColor="#F4DDA1" />
        </linearGradient>
        <linearGradient
          id="glow-logo-svg__g"
          x1="-11.486"
          x2="64.987"
          y1="18"
          y2="18"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB2287" stopOpacity=".9" />
          <stop offset=".797" stopColor="#F4DDA1" />
        </linearGradient>
        <clipPath id="glow-logo-svg__a">
          <rect width="72" height="72" fill="#fff" rx="36" />
        </clipPath>
        <clipPath id="glow-logo-svg__i">
          <path fill="#fff" d="M20 20h32v32H20z" />
        </clipPath>
      </defs>
    </Box>
  );
}
